enum TipoRequisitoEnum {
    Validacion = 'V',
    Documento = 'D'
}

export default TipoRequisitoEnum;